'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookLoma = require('@narvar/nth-hook-loma');

function useIsGrowthBookFeatureOn({
  feature,
  project,
  attributes,
  anonymousId,
  sourceWriteKey
}) {
  const result = nthHookLoma.useIsGrowthBookFeatureOnQuery({
    variables: {
      project,
      feature,
      attributes,
      anonymousId,
      sourceWriteKey
    }
  });
  const enabled = result.data?.isGrowthBookFeatureOn ?? false;
  return {
    enabled,
    result
  };
}
function useIsTrackFeatureOn(feature) {
  const {
    state: {
      retailerMoniker,
      localeCountry,
      localeLanguage,
      trackingStatus,
      trackingNumbers,
      orderNumbers
    }
  } = nthHookContextPage.usePageContext();
  const [orderNumber] = orderNumbers ?? [];
  const [trackingNumber] = trackingNumbers ?? [];
  const attributes = {
    track_localeCountry: localeCountry,
    track_localeLanguage: localeLanguage,
    track_orderNumber: orderNumber,
    track_retailerMoniker: retailerMoniker,
    track_shipmentStatus: trackingStatus,
    track_trackingNumber: trackingNumber
  };
  return useIsGrowthBookFeatureOn({
    project: 'TRACK',
    feature,
    attributes,
    sourceWriteKey: retailerMoniker
  });
}

exports.useIsGrowthBookFeatureOn = useIsGrowthBookFeatureOn;
exports.useIsTrackFeatureOn = useIsTrackFeatureOn;
